import React from "react";
import { Link } from "react-router-dom";
import PageHero from "../components/PageHero";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/projects-gallery", label: "Projects" },
  { to: "/contact-us", label: "Contact Us" },
];

function NotFoundPage() {
  return (
    <>
      <PageHero
        title="Page not found"
        crumb="404"
        subtitle="The page you were looking for doesn't exist or has moved."
      />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24 text-center">
        <p className="text-lg text-gray-700">Try one of these instead:</p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          {links.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              className="rounded-full border-2 border-brand-navy px-6 py-2.5 font-semibold text-brand-navy transition-colors hover:bg-brand-navy hover:text-white"
            >
              {label}
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}

export default NotFoundPage;
